import React, { ReactNode } from 'react'
import { Text } from 'react-native'
import styles from './styles'
import HGText from './HGText'

type Props = React.ComponentProps<typeof Text> & {
  children: ReactNode
  // numberOfLines: number
  // ellipsizeMode: string
}

const HGHeading = (props: Props) => {
  const { children, style /* onPress, numberOfLines, ellipsizeMode */ } = props

  return (
    <HGText {...props} style={[styles.textHeading, style]}>
      {children}
    </HGText>
  )
}

export default HGHeading
